import { Avatar, Paper } from "@material-ui/core";
import { FC, ReactNode, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { BOLETO, CARTAO_CREDITO, FINANCIMENTO_INDIRETO, ETAPA_PAGAMENTO_NEGOCIACAO, FINANCIAMENTO, BOLETO_FINANCIAMENTO_INDIRETO, BOLETO_CARTAO, ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO, PIX, PIX_CARTAO, PIX_FINANCIAMENTO_INDIRETO, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO, BOLETO_FINANCIAMENTO, PIX_FINANCIAMENTO, CARTAO_FINANCIAMENTO, FINAME, MIN_VALOR_PEDIDO, FORMAS_COM_FINANCIAMENTO_VIA_PLATAFORMA } from "src/constants";
import { CollectionUtil } from "src/framework/commons";
import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { confirmationDialog, notifierStore } from "src/framework/store";
import { useObservable } from "src/framework/store/storeUtil";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";
import { PedidoStore } from "src/store/vendas/PedidoStore";
import { FormaPagamentoType, PagamentoType, PedidoPagamento, PedidoPagamentoResponse, PedidoType } from "src/types";
import { BoletoCartaoCredito } from "./BoletoCartaoCredito";
import { BoletoFinanciamento } from "./BoletoFinanciamento";
import { BoletoFinanciamentoIndireto } from "./BoletoFinanciamentoIndireto";
import { BoletoSolo } from "./BoletoSolo";
import { CartaoAPrazo } from "./CartaoAPrazo";
import { CartaoCreditoFinanciamento } from "./CartaoCreditoFinanciamento";
import { CartaoCreditoFinanciamentoIndireto } from "./CartaoCreditoFinanciamentoIndireto";
import { FinanciamentoIndiretoSolo } from "./FinanciamentoIndiretoSolo";
import { FinanciamentoSolo } from "./FinancimentoSolo";
import { FormaPagamento } from "./FormaPagamento";
import { GrupoPagamento } from "./GrupoPagmento";
import { PixCartaoCredito } from "./PixCartaoCredito";
import { PixFinanciamento } from "./PixFinanciamento";
import { PixFinanciamentoIndireto } from "./PixFinanciamentoIndireto";
import { PixSolo } from "./PixSolo";
import { Resumo } from "./Resumo";
import { FINAMESolo } from "./FINAMESolo";
import "./styles.scss";
import { parseCurrency } from "src/framework/commons/masks";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";


interface TipoPagamentoProperties {
    pagamento: PagamentoType | null;
}

type GrupoTipoPagamentoType = "mesclagem"

const PEDIDO_PAGAMENTO_DEFAULT = {
    pedido: 0,
    forma_pagamento: 0,
    itens: {}
}

const pedidosProvider = new PedidosProvider();

const TiposPagamento: FC<TipoPagamentoProperties> = ({
    pagamento
}) => {
    const history = useHistory()

    const [selected, setSelected] = useState<FormaPagamentoType | null>(null);
    const [tipoGrupoPagamento, setTipoGrupoPagamento] = useState<GrupoTipoPagamentoType | null>(null);
    const [disabledConfirmar, setDisableConfirmar] = useState<boolean>(true);
    const [disabledFormasPagamento, setDisableFormasPagamento] = useState<boolean>(false);
    const pedidoState = useObservable<PedidoType>(PedidoStore.getPedidoSubject())
    const [formasPagamentoState, setFormasPagamentoState] = useState<FormaPagamentoType[] | any>(null)
    const [pedidoPagamento, setPedidoPagamento] = useState<PedidoPagamento>(PEDIDO_PAGAMENTO_DEFAULT)

    const [qtdCartoes, setQtdCartoes] = useState<number>(0);

    const pedido = PedidoStore.getPedido()

    const init = async () => {
        if (pedido?.codigo_venda) {
            const responses = await Promise.all([
                pagamentoProvider.getFormasPagamento(pedido?.codigo_venda)
            ])
            setFormasPagamentoState(responses[0])
        }
    }
    useEffect(() => {
        init();
    }, [])

    const handleClickTipoPagamento = (tipoPagamento: FormaPagamentoType): void => {
        if (selected) {
            confirmationDialog.setup({
                title: "Aviso!!!",
                content: "Ao navegar entre as formas de pagamento disponíveis, as informações já preenchidas no formulário atual serão perdidas! Deseja prosseguir?",
                onClose: () => {
                    confirmationDialog.close();
                },
                onConfirmation: () => {
                    setSelected(tipoPagamento);
                    confirmationDialog.close();
                },    
            })
            confirmationDialog.open();
        } else {
            setSelected(tipoPagamento);
        }       
        return;
    }

    const confirmarPagamento = async (pedidoPagamento: PedidoPagamento, pedido: PedidoType): Promise<void> => {
        try {
            const _pedidoPagamento: any = pedidoPagamento;

            const response: IDataResponse<PedidoPagamentoResponse> = await pagamentoProvider.confirmarPagamento(pedido.codigo_venda, _pedidoPagamento);

            if (response.statusCode !== STATUS_CODE.OK) {
                notifierStore.setNotifier({
                    title: "Aviso!!!",
                    content: ["Erro ao efetuar pagamento.", "Tente novamente", ...response.message],
                    timeOut: 3500,
                    onClose: () => {
                        setDisableConfirmar(true)
                        setDisableFormasPagamento(false);
                        setPedidoPagamento(CollectionUtil.merge({}, PEDIDO_PAGAMENTO_DEFAULT))
                        notifierStore.setOpen(false);
                    }
                })
                notifierStore.setOpen(true);
                return;
            }

            if (response.statusCode === STATUS_CODE.OK) {
                if (response.data.etapa_pagamento === ETAPA_PAGAMENTO_NEGOCIACAO.id) {
                    const mensagem: string[] = [];

                    mensagem.push("Pagamento registrado com sucesso.")
                    mensagem.push("Em breve retornaremos a situação do pagamento.")

                    notifierStore.setNotifier({
                        title: "Aviso!!!",
                        content: mensagem,
                        timeOut: 3500,
                        onClose: () => {
                            notifierStore.setOpen(false);
                            window.location.href = window.location.origin + "/"
                            return;
                        }
                    })
                    notifierStore.setOpen(true);
                    return;
                } else if (response.data.etapa_pagamento === ETAPA_PAGAMENTO_COMPLEMENTO_PAGAMENTO.id) {

                    notifierStore.setNotifier({
                        title: "Aviso!!!",
                        content:  <>
                            <p>
                                Pagamento PARCIAL efetuado, encontramos um problema em uma das suas forma de pagamento
                                <br />Lhe retornaremos para a tela inicial para efetuar o complemento de pagamento
                            </p>
                            {response.data.pagamentos?.cartoes_credito?.find(y => y.situacao === "recusado") && (<>
                                <br />Cartão de crédito recusado
                                <ul>
                                    <li>Entre em contato com sua operadora do cartão para autorização da compra on-line;</li>
                                    <li>Verifique o limite do cartão;</li>
                                    <li>Após seguir as validações acima, efetue o novo pagamento.</li>
                                </ul>
                            </>)}

                            {response.data.pagamentos?.boletos?.find(y => y.situacao === "recusado") && (<>
                                <br />Boleto recusado
                            </>)}

                            {response.data.pagamentos?.cartas_credito?.find(y => y.situacao === "recusado") && (<>
                                <br />Carta de crédito recusada
                            </>)}

                            {response.data.pagamentos?.pix?.find(y => y.situacao === "recusado") && (<>
                                <br />PIX recusado
                            </>)}

                            {response.data.pagamentos?.financiamento?.find(y => y.situacao === "recusado") && (<>
                                <br />Financiamento recusado
                            </>)}
                        </>,
                        timeOut: 3500,
                        onClose: () => {
                            notifierStore.setOpen(false);
                            history.push("/");
                            return;
                        }
                    })
                    notifierStore.setOpen(true);
                } else {

                    if (response.data.pagamentos.cartoes_credito?.length) {
                        const cartaoRecusado = response.data.pagamentos.cartoes_credito?.find(c => c.situacao === "recusado");
    
                        if (cartaoRecusado) {
                            notifierStore.setNotifier({
                                title: "Aviso!!!",
                                content: <>
                                    <p>
                                        Informamos que não foi possível realizar o pagamento com a opção selecionada.
                                        <br />Dessa forma, sugerimos que:
                                    </p>
                                    <ul>
                                        <li>Entre em contato com sua operadora do cartão para autorização da compra on-line;</li>
                                        <li>Verifique o limite do cartão;</li>
                                        <li>Após seguir as validações acima, efetue o novo pagamento.</li>
                                    </ul>
                                </>,
                                timeOut: 3500,
                                onClose: () => {
                                    setDisableConfirmar(true)
                                    setDisableFormasPagamento(false);
                                    setPedidoPagamento(CollectionUtil.merge({}, PEDIDO_PAGAMENTO_DEFAULT))
                                    notifierStore.setOpen(false);
                                }
                            });
                            notifierStore.setOpen(true)
                            return;
                        }
                    }

                    const mensagem: string[] = [];

                    mensagem.push("Houve um erro ao efetuar seu pagamento!")
                    mensagem.push("Tente novamente ou selecione uma nova forma de pagamento");

                    var responseNew : any = response.data;
                    const PEDIDO = {
                        pedido: responseNew.novo_pagamento_id,
                        forma_pagamento: 0,
                        itens: {}
                    }
                    
                    notifierStore.setNotifier({
                        title: "Aviso!!!",
                        content: mensagem,
                        timeOut: 3500,
                        onClose: () => {
                            setDisableFormasPagamento(false);
                            setDisableConfirmar(true)
                            setPedidoPagamento({ ...PEDIDO_PAGAMENTO_DEFAULT })
                            notifierStore.setOpen(false);
                            return;
                        }
                    })
                    notifierStore.setOpen(true);
                    return;
                }
            }
        } catch (error) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: ["Erro ao efetuar pagamento"],
                timeOut: 3500,
                onClose: () => {
                    setDisableFormasPagamento(false);
                    setDisableConfirmar(true)
                    setPedidoPagamento({ ...PEDIDO_PAGAMENTO_DEFAULT })
                    notifierStore.setOpen(false);
                    return;
                }
            })
            notifierStore.setOpen(true);
        }
    }

    const valorEstaAbaixoDoValorMinimoParaFinanciamentoPlataforma = useCallback((id: number): boolean => {
        if (FORMAS_COM_FINANCIAMENTO_VIA_PLATAFORMA.includes(id)){
            return Number(pedido?.valor_pedido || 0) < MIN_VALOR_PEDIDO 
        }
        return false
    },[pedido])

    const mostraAvisoDeValorMínimo = useCallback(()=>{
        const formattedMoneyValue = Intl.NumberFormat('pt-BR', { style: "currency", currency: "BRL" }).format(MIN_VALOR_PEDIDO)
        notifierStore.setNotifier({
            title: "Aviso!",
            content: (
                <>
                    <span>Não é possível financiar projetos com valor inferior a {formattedMoneyValue}.</span><br/>
                    <span>Selecione outra forma de pagamento ou dimensione um novo projeto com valor superior a {formattedMoneyValue}.</span>
                </>
            ),
            onClose: () => notifierStore.setOpen(false),
            timeOut: 25000
        })
        notifierStore.setOpen(true)
    },[])


    const hasPagamento = (): boolean => {
        const boletos = pedidoPagamento?.itens?.boletos?.length || 0
        const cartas_credito = pedidoPagamento?.itens?.cartas_credito?.length || 0
        const cartoes_credito = pedidoPagamento?.itens?.cartoes_credito?.length || 0
        const pix = pedidoPagamento?.itens?.pix?.length || 0
        const financiamentos = pedidoPagamento?.itens?.financiamento?.length || 0

        return boletos > 0 || cartas_credito > 0 || cartoes_credito > 0 || pix > 0 || financiamentos > 0;
    }


    const renderTipoPagamento = (): ReactNode => {
        return <>
            <div className="row">
                {formasPagamentoState?.filter((f: FormaPagamentoType) => !f.mesclagem)?.map((f: FormaPagamentoType, index: number) => {
                    if (f.id === CARTAO_CREDITO.id) {
                        if (qtdCartoes === 0) {
                            setQtdCartoes(f.quantidade)
                        }
                    }
                    return (<div className="X12" key={`forma-pagamento-${f.id}-${index}`}>
                        <FormaPagamento
                            formaPagamento={f}
                            disabled={disabledFormasPagamento}
                            onSelected={async () => {
                                if (!pedido?.codigo_venda) return;
                                const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                                if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                                const valorAbaixo = valorEstaAbaixoDoValorMinimoParaFinanciamentoPlataforma(f.id)
                                if (valorAbaixo) {
                                    mostraAvisoDeValorMínimo()
                                    return
                                }
                                handleClickTipoPagamento(f)
                            }}
                            selected={selected?.id === f.id && !selected.mesclagem}
                        />
                    </div>)
                })}
            </div>

            <GrupoPagamento title="Múltiplas formas" open={tipoGrupoPagamento === "mesclagem"} onOpenChage={(isOpen) => {
                setTipoGrupoPagamento(isOpen ? "mesclagem" : null)
            }}>
                <div className="row">
                    
                    {formasPagamentoState?.filter((f: FormaPagamentoType) => f.mesclagem)?.map((f: FormaPagamentoType, index: number) => {
                        return (<div className="X12" key={`forma-pagamento-mescladas-${f.id}-${index}`}>
                            <FormaPagamento
                                formaPagamento={f}
                                disabled={disabledFormasPagamento}
                                onSelected={async () => {
                                    if (!pedido?.codigo_venda) return;
                                    const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                                    if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                                    const valorAbaixo = valorEstaAbaixoDoValorMinimoParaFinanciamentoPlataforma(f.id)
                                    if (valorAbaixo) {
                                        mostraAvisoDeValorMínimo()
                                        return
                                    }
                                    handleClickTipoPagamento(f)
                                }}
                                selected={selected?.id === f.id && selected.mesclagem}
                            />
                        </div>)
                    })}
                </div>
            </GrupoPagamento>
        </>;
    }

    return <div className="TipoPagamento row X--stretch">
        <div className="X12 S6 M2">
            <div className={"listagemTipoPagamento"}>
                <Paper className={"paper"} elevation={0}>
                    <div className="row steps">
                        <div className="X12">
                            <div className="step">
                                <Avatar>1</Avatar> Forma de pagamento
                            </div>
                        </div>
                        <div className="X12">
                            Selecione a forma de pagamento
                        </div>
                    </div>
                    {renderTipoPagamento()}
                </Paper>
            </div>
        </div>
        <div className="X12 S7 M7">
            <Paper className={"paper"} elevation={0}>
                <div className="row steps">
                    <div className="X12">
                        <div className="step">
                            <Avatar>2</Avatar> Detalhes da forma de pagamento
                        </div>
                    </div>
                </div>
                
                {!selected && !hasPagamento() && <>
                    <p>Selecione uma forma de pagamento</p>
                </>}
                
                {hasPagamento() && <>
                    <p>Revise as informações e finalize a compra</p>
                </>}

                {selected?.id === PIX.id && !selected?.mesclagem  && <>
                    <PixSolo
                        pedido={pedidoState || null}
                        onIsValid={(isValid) => {
                            setDisableConfirmar(!isValid)
                        }}
                        onConfirmar={async (pagamento, tipoPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            setPedidoPagamento(state)
                            // setTipoPagamentoConfirmado(tipoPagamento)
                            setSelected(null);
                        }}
                    />
                </>}

                {selected?.id === BOLETO.id && !selected?.mesclagem && <>
                    <BoletoSolo
                        pedido={pedidoState || null}
                        onIsValid={(isValid) => {
                            setDisableConfirmar(!isValid)
                        }}
                        onConfirmar={async (pagamento, tipoPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            setPedidoPagamento(state)
                            setSelected(null);
                        }}
                    />

                </>}
                
                {selected?.id === CARTAO_CREDITO.id && !selected?.mesclagem && <>
                    <CartaoAPrazo
                        pedido={pedidoState || null}
                        qtdParcelas={pedido?.etapa_pagamento === "complemento_pagamento" ? 1 : undefined}
                        qtdCartoes={qtdCartoes}
                        onIsValid={(isValid) => {
                            setDisableConfirmar(!isValid)
                        }}
                        onConfirmar={async (pagamento, tipoPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            setPedidoPagamento(state)
                            // setTipoPagamentoConfirmado(tipoPagamento)
                            setSelected(null);
                        }}
                    />
                </>}
                {selected?.id === FINANCIMENTO_INDIRETO.id && !selected?.mesclagem && <>
                    <FinanciamentoIndiretoSolo
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            setPedidoPagamento(state)
                            setSelected(null);
                        }} />
                </>}
                {selected?.id === FINAME.id && !selected?.mesclagem && <>
                    <FINAMESolo
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            setPedidoPagamento(state)
                            setSelected(null);
                        }} />
                </>}
                {selected?.id === BOLETO_FINANCIAMENTO_INDIRETO.id && selected?.mesclagem && <>
                    <BoletoFinanciamentoIndireto
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                        }} />
                </>}
                {selected?.id === BOLETO_CARTAO.id && selected?.mesclagem && <>
                    <BoletoCartaoCredito
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                        }} />
                </>}

                {selected?.id === BOLETO_FINANCIAMENTO.id && selected?.mesclagem && <>
                    <BoletoFinanciamento
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                    }} />
                </>}

                {selected?.id === PIX_FINANCIAMENTO.id && selected?.mesclagem && <>
                    <PixFinanciamento
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                        }} />
                </>}

                {selected?.id === FINANCIAMENTO.id && !selected.mesclagem && <>
                    <FinanciamentoSolo
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            setPedidoPagamento(state)
                            setSelected(null);
                        }}
                    />
                </>}

                

                {selected?.id === PIX_CARTAO.id && selected?.mesclagem && <>
                    <PixCartaoCredito
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                        }} />

                </>}

                {selected?.id === CARTAO_FINANCIAMENTO.id && selected?.mesclagem && <>
                    <CartaoCreditoFinanciamento
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                        }} />

                </>}

                {selected?.id === PIX_FINANCIAMENTO_INDIRETO.id && selected?.mesclagem && <>
                    <PixFinanciamentoIndireto
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                        }} />
                </>}

                {selected?.id === CARTAO_CREDITO_FINANCIAMENTO_INDIRETO.id && selected?.mesclagem && <>
                    <CartaoCreditoFinanciamentoIndireto
                        pedido={pedidoState || null}
                        onConfirmar={async (pagamento, tipoPagamento, fecharPagamento) => {
                            if (!pedido?.codigo_venda) return;
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda)
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return

                            const state: PedidoPagamento = CollectionUtil.merge({}, pagamento)
                            state.forma_pagamento = tipoPagamento

                            if (fecharPagamento) {
                                setPedidoPagamento(state)
                                setSelected(null);
                            }
                        }} />

                </>}
            </Paper>
        </div>
        <Resumo
            disabled={disabledConfirmar}
            pedido={pedidoState}
            pedidoPagamento={pedidoPagamento}
            onFinalizarPagamento={(_pagamento) => {
                const { pagamentoPedido, pedido } =  _pagamento;
                confirmarPagamento(pagamentoPedido, pedido);
            }}
            onRemove={(newState) => {
                setPedidoPagamento(newState)
                setDisableConfirmar(true)
                setDisableFormasPagamento(false)
            }}
            onDisableFormasPagamento={(_disabledFormasPagamento) => {
                setDisableFormasPagamento(_disabledFormasPagamento)
            }}
        />

        {/* <BaixarBoleto
            pagamentoId={pedidoState?.pagamento_id}
            open={openBaixarBoleto}
            onConfirm={() => { }}
            onClose={() => {
                history.push("/");
            }}
        />

        <GerarQRCodePix
            codigo_venda={pedidoState?.codigo_venda}
            open={openGerarPix}
            onConfirm={() => { }}
            onClose={() => {
                history.push("/");
            }}
        />

        {openFinancimentoForm && pedidoState?.codigo_venda
            // && pedidoState.situacao === SITUACAO_PAGAMENTO_PENDENTE.id
            && <FinanciamentoForm
                codigoVenda={pedidoState?.codigo_venda}
                open={openFinancimentoForm}
                onConfirm={() => { }}
                onClose={() => {
                    setOpenFinancimentoForm(false);
                    history.push("/");
                }}
            />} */}
    </div>
}

export { TiposPagamento }